import { BREADCRUMB_NAVIGATION_LINK_TYPES } from 'constants/breadcrumbNavigation';

export const BREADCRUMB_TRAIL_REMAPPINGS = {
  '/collections/mens': {
    handle: 'sale-mens-shoes',
    type: BREADCRUMB_NAVIGATION_LINK_TYPES.COLLECTION,
  },
  '/collections/womens': {
    handle: 'sale-womens-shoes',
    type: BREADCRUMB_NAVIGATION_LINK_TYPES.COLLECTION,
  },
  '/collections/mens-apparel': {
    handle: 'sale-mens-apparel',
    type: BREADCRUMB_NAVIGATION_LINK_TYPES.COLLECTION,
  },
  '/collections/womens-apparel': {
    handle: 'sale-womens-apparel',
    type: BREADCRUMB_NAVIGATION_LINK_TYPES.COLLECTION,
  },
};
